import { Access, type RequestOf } from "@p0security/shared/types/access/index";

export const SalesforceAccesses = {
  "permission-set": Access({
    label: "Permission set",
    description: "Gain a permission set",
    maturity: "preview",
    delegation: {},
    parameters: {
      domain: {
        type: "static",
        label: "Salesforce domain",
        optional: true,
      },
      domainId: {
        type: "generated",
        label: "Salesforce domain (resolved)",
      },
      id: {
        type: "static",
        label: "Permission set ID",
        multivalued: true,
      },
      name: {
        type: "generated",
        label: "Permission set name",
        multivalued: true,
      },
      userId: {
        type: "generated",
        label: "Salesforce user ID",
      },
    },
    generated: {},
    render: { locator: "domain", policy: "name" } as const,
  }),
};

export type SalesforceAccesses = typeof SalesforceAccesses;

export type SalesforcePermissionSetAccess =
  SalesforceAccesses["permission-set"];

export type SalesforcePermissionSetRequest =
  RequestOf<SalesforcePermissionSetAccess>;
